<template>
  <ibox>
    <template slot="title">登録企業一覧</template>
    <template slot="tools">
      <router-link to="/company/create">
        <button class="btn btn-info btn-outline btn-xs btn-bitbucket">
          企業登録
        </button>
      </router-link>
    </template>
    <template slot="body">
      <div class="row">
        <div class=" col-sm-12 form-horizontal">
          <company-search
            :params.sync="params"
            @click="companySearch"></company-search>
        </div>
        <div class=" col-sm-12">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>企業名</th>
              <th style="min-width: 200px;word-break: break-all">URL</th>
              <th>
              </th>
            </tr>
            </thead>
            <tbody>
            <template v-for="company in companies">
              <company-list-row :company="company" @search="companySearch"></company-list-row>
            </template>
            </tbody>
          </table>
          <pager @click="clickPager" v-bind:pager="pager"></pager>
        </div>
      </div>
    </template>
  </ibox>

</template>

<script>
  import Api from '../../service/Api.vue'
  import CompanySearch from '../../components/company/Search.vue'

  export default {
    created: function () {
      this.companySearch({})
    },
    watch: {
      $route: {
        deep: true,
        handler: function () {

        }
      }
    },
    data () {
      return {
        params: {},
        companies: [],
        pager: false
      }
    },
    methods: {
      clickPager: function (page) {
        this.params.page = page
        this.companySearch(this.params)
      },
      companySearch: function (data) {
        data.order = 'updated_at'
        data.sort = 'DESC'
        this.params = data

        Api.company.search(data).then(this.searchSuccess)
      },
      searchSuccess: function (response) {
        this.companies = response.data.companies
        // this.companies.sort()
        this.pager = response.data.pager
      }
    },
    components: {
      CompanySearch
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?aa25ac86